import userReducer from './reducers/userSlice'
export const rootReducer = {
    // ...your other reducers here
    user: userReducer,
}